import React, { Component } from 'react';
import Header from '../../Header/Header';
import { history } from '../../helpers/history';
import { Helmet } from "react-helmet";

class JackpotLottery extends Component {
    constructor(props) {
        super(props);
    }

    ClickGame = (idclk) => {
        history.push(idclk)
    }
    render() {
        return (
            <div>
                {process.env.REACT_APP_MODE != "development" &&
                    <Helmet>
                        <title>Jackpot Lottery Malaysia – Play Online & Win Big | GulfTicket</title>
                        <meta name="description" content="Play Jackpot Lottery in Malaysia with GulfTicket. Secure draws, huge prizes, and easy ticketing. Explore top games like Magic5, Rush3, and Dream5" />
                        <meta name="keywords" content="jackpot lottery India, online jackpot lottery India" />
                        <meta property="og:title" content={`Jackpot Lottery Malaysia – Play Online & Win Big | GulfTicket`} />
                        <meta property="og:site_name" content="Gulf Ticket" />
                        <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                        <meta property="og:description" content="Play Jackpot Lottery in Malaysia with GulfTicket. Secure draws, huge prizes, and easy ticketing. Explore top games like Magic5, Rush3, and Dream5" />
                        <meta property="og:type" content="website" />
                        <meta property="og:image" content="https://gulfticket.com/assets/img/logo.png" />
                    </Helmet>
                }
                <Header />
                <div class="wrap2 contentalign gameGuide">
                    <div class="px-1 mt-5 mb-20">
                        <h1 class="text-base lg:text-xl font-semibold">Jackpot Lottery Malaysia – Win Big with GulfTicket</h1>                        
                        <h3 class="text-base lg:text-xl font-semibold">Unlock Life-Changing Wins</h3>                        
                        <p class="mt-3">The dream of winning big is now real. GulfTicket’s Jackpot Lottery gives Malaysians the chance to win massive prizes through a simple, secure platform. Whether you’re in <b>Malaysia or India</b>, our platform connects you to high-reward draws.</p>                                                
                        <div class="border-line"></div>

                        <h3 class="text-base lg:text-xl font-semibold">What Is the Jackpot Lottery?</h3>
                        <h4 class="text-base lg:text-xl font-semibold">Trusted Platform</h4>
                        <p class="mt-3">GulfTicket offers a legal, transparent, and secure lottery system. Thousands across Malaysia and India play daily, trusting our verified draw process.</p>
                        <h4 class="text-base lg:text-xl font-semibold">Fast Ticketing</h4>
                        <p class="mt-3">Buy tickets online in minutes—no paperwork, no agents. Select your numbers, pay securely, and wait for the draw.</p>
                        <h4 class="text-base lg:text-xl font-semibold">Affordable & Scalable</h4>
                        <p class="mt-3">Start with a small ticket price. Join with one ticket or boost your odds with multiple entries.</p>
                        <div class="border-line"></div>
                        <h3 class="text-base lg:text-xl font-semibold">How to Play Jackpot Lottery in Malaysia</h3>
                        <h4 class="text-base lg:text-xl font-semibold">1. Select Ticket</h4>
                        <p class="mt-3"> Go to the <a onClick={() => { this.ClickGame('/home') }}>Jackpot Lottery page</a> and choose ticket quantity.</p>
                        <h4 class="text-base lg:text-xl font-semibold">1. Pick Numbers</h4>
                        <p class="mt-3">Select your numbers or use auto-pick.</p>
                        <h4 class="text-base lg:text-xl font-semibold">1. Pick Numbers</h4>
                        <p class="mt-3">Select your numbers or use auto-pick.</p>
                        <h4 class="text-base lg:text-xl font-semibold">1. Secure Checkout</h4>
                        <p class="mt-3"> Pay via supported Malaysian payment methods.</p>
                        <h4 class="text-base lg:text-xl font-semibold">1. Wait for Results</h4>
                        <p class="mt-3"> Results are announced as per the published schedule. Winners are notified instantly.</p>
                        <div class="border-line"></div>
                        <h3 class="text-base lg:text-xl font-semibold">Is GulfTicket Legit?</h3>
                        <p class="mt-3">Yes. GulfTicket is widely used in the UAE, India, and Malaysia. All games follow a verified, traceable process. Your winnings go straight into your wallet, ready for withdrawal after ID verification.</p>
                        <div class="border-line"></div>
                        <h3 class="text-base lg:text-xl font-semibold">Better Than Offline Lotteries</h3>
                        <div class="mt-3">
                            <ul class="list-disc pl-5 lg:pl-7 rtl:pr-5 lg:rtl:pr-7">
                                <li>No agents, no delay</li>
                                <li>Transparent draw records</li>
                                <li>Mobile-friendly access</li>
                                <li>Automatic result notifications</li>                                
                            </ul>
                        </div>
                        <div class="border-line"></div>
                        <h3 class="text-base lg:text-xl font-semibold">What’s in it for You?</h3>
                        <div class="mt-3">
                            <ul class="list-disc pl-5 lg:pl-7 rtl:pr-5 lg:rtl:pr-7">
                                <li><b>Big Rewards</b>: Prizes up to millions</li>
                                <li><b>Low Entry Cost</b>: Play from AED 5 (~MYR 6.25)</li>
                                <li><b>Multiple Chances</b>: Play more, win more</li>                                
                            </ul>
                        </div>
                        <div class="border-line"></div>
                        <h3 class="text-base lg:text-xl font-semibold">Why Malaysians Play on GulfTicket</h3>
                        <div class="mt-3">
                            <ul class="list-disc pl-5 lg:pl-7 rtl:pr-5 lg:rtl:pr-7">
                                <li>Local payment options</li>
                                <li>Multi-language support</li>
                                <li>Games designed for daily, weekly, and monthly draws</li>                                
                                <li>Safe, fast, mobile-ready interface</li>                                
                            </ul>
                        </div>
                        <div class="border-line"></div>
                        <h3 class="text-base lg:text-xl font-semibold">Want More Chances to Win?</h3>
                        <p class="mt-3">Explore these other exciting games on GulfTicket:</p>
                        <div class="mt-3">
                            <ul class="list-disc pl-5 lg:pl-7 rtl:pr-5 lg:rtl:pr-7">
                                <li>🔗 Lucky1 1D – Daily quick-draw game</li>
                                <li>🔗 Rush3 3D – Triple digit wins</li>
                                <li>🔗 Dream5 5D – 5-digit dream draw</li>                                
                                <li>🔗 Magic5 5D – Win up to AED 1.25M</li>                                
                                <li>🔗 Fortune6 6D – High-stake lottery</li>                                
                                <li>🔗 Super6 6D – Grand prize AED 225M</li>                                
                            </ul>
                        </div>
                        <p class="mt-3">Yes. GulfTicket is widely used in the UAE, India, and Malaysia. All games follow a verified, traceable process. Your winnings go straight into your wallet, ready for withdrawal after ID verification.</p>
                        <div class="border-line"></div>

                        <h3 class="text-base lg:text-xl font-semibold">FAQs (Based on NEPQ)</h3>
                        <h4 class="text-base lg:text-xl font-semibold">Q: Can I play from Malaysia?</h4>
                        <p class="mt-3"> Yes, the platform is open to Malaysian players.</p>
                        <h4 class="text-base lg:text-xl font-semibold">Q: Is it legal?</h4>
                        <p class="mt-3"> Yes, GulfTicket is a compliant, region-supported platform.</p>
                        <h4 class="text-base lg:text-xl font-semibold">Q: How do I get paid?</h4>
                        <p class="mt-3"> Winnings go into your GulfTicket wallet. Withdraw after ID verification.</p>
                        <div class="border-line"></div>

                        <h3 class="text-base lg:text-xl font-semibold">Final Words</h3>
                        <p class="mt-3">Your winning journey starts with one step. The Jackpot Lottery Malaysia by GulfTicket brings global-standard gaming to your fingertips. With fast ticketing, secure systems, and life-changing rewards—there’s no better time to play.</p>
                        <p class="mt-3">Explore more games like <a onClick={() => { this.ClickGame('/dream5') }}>Dream5</a>, <a onClick={() => { this.ClickGame('/magic5') }}>Magic5</a>, and <a onClick={() => { this.ClickGame('/super6') }}>Super6</a> to multiply your chances.</p>                       
                    </div>
                </div>
            </div>
        )
    }

}

export default JackpotLottery